import {ComponentData} from "../../engine/tools/EntityManager";
import {Vector2} from "../../engine/utils/Vector2";

export class Position implements ComponentData {
    value: Vector2

    constructor(x?: number | Vector2, y?: number) {
        this.value = new Vector2(x, y)
    }

}